import { render, staticRenderFns } from "./CLesson.vue?vue&type=template&id=0517e543"
import script from "./CLesson.vue?vue&type=script&lang=js"
export * from "./CLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0517e543')) {
      api.createRecord('0517e543', component.options)
    } else {
      api.reload('0517e543', component.options)
    }
    module.hot.accept("./CLesson.vue?vue&type=template&id=0517e543", function () {
      api.rerender('0517e543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CLesson.vue"
export default component.exports